import { memo } from "react";
import { Stack, Text } from "@fluentui/react";
import type { TurnFollowup } from "../chatTurn";
import followupStyles from "./FollowupQuestions.module.css";

interface FollowupQuestionsProps {
  questions: TurnFollowup[];
  onQuestionClick: (question: TurnFollowup) => void;
}

export const FollowupQuestions = memo(({ questions, onQuestionClick }: FollowupQuestionsProps) => {
  if (!questions || questions.length === 0) {
    return null;
  }

  return (
    <Stack className={followupStyles.container} tokens={{ childrenGap: 8 }}>
      <Text className={followupStyles.header}>Related Questions:</Text>
      <Stack horizontal wrap tokens={{ childrenGap: 8 }}>
        {questions.map(question => (
          <div
            key={question.id}
            className={followupStyles.followup}
            onClick={() => onQuestionClick(question)}
            onKeyDown={e => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onQuestionClick(question);
              }
            }}
            tabIndex={0}
            role="button"
            aria-label={`Ask: ${question.question}`}
          >
            <span className={followupStyles.text}>{question.question}</span>
          </div>
        ))}
      </Stack>
    </Stack>
  );
});
